<template>
  <v-snackbar v-model="snackbarStore.visible" :color="snackbarStore.color" :timeout="snackbarStore.timeout">
    {{ snackbarStore.text }}
    <template v-slot:actions>
      <v-btn variant="text" @click="snackbarStore.close()">{{ $t('general.close') }}</v-btn>
    </template>
  </v-snackbar>
</template>

<script>
import { useSnackbarStore } from '@/store/snackbar';

/**
 * Mounted once, globally, in App.vue. Views never render their own
 * <v-snackbar> - they call useSnackbarStore().showSuccess(...) / showError(...)
 * and this is the only place the notification actually renders.
 */
export default {
  name: 'AppSnackbar',

  setup() {
    const snackbarStore = useSnackbarStore();
    return { snackbarStore };
  }
};
</script>
